import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { blogAPI } from '../../utils/api';

export default function BlogPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['blog-posts'],
    queryFn: () => blogAPI.getAll({ page: 1, limit: 12 }).then((res) => res.data),
  });

  const posts = data?.posts || [];

  return (
    <div className="page-container" style={{ paddingTop: 80, paddingBottom: 80 }}>
      <div style={{ marginBottom: 24 }}>
        <Link to="/" className="btn btn-ghost">← Kthehu në Shtëpi</Link>
      </div>
      <div className="page-header">
        <div>
          <p className="section-eyebrow">Blog</p>
          <h1 className="page-title">Më të fundit nga HairFix</h1>
          <p className="page-sub">Lexoni këshilla bukurie, përbërës natyralë dhe histori suksesi.</p>
        </div>
      </div>

      {isLoading ? (
        <div className="loading-screen"><div className="spinner" /></div>
      ) : isError ? (
        <div style={{ textAlign: 'center', padding: 40 }}><p>Gabim gjatë ngarkimit të artikujve.</p></div>
      ) : posts.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📝</div>
          <h3>Nuk ka artikuj të publikuar</h3>
          <p>Provoni përsëri më vonë.</p>
        </div>
      ) : (
        <div className="blog-grid">
          {posts.map((post) => (
            <article key={post.id} className="blog-card">
              {post.cover_image && <img src={post.cover_image} alt={post.title} />}
              <div className="blog-card-body">
                <div className="blog-card-meta">{new Date(post.published_at).toLocaleDateString('sq')} · {post.comment_count || 0} komente</div>
                <h2>{post.title}</h2>
                <p>{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="btn btn-outline">Lexo më shumë</Link>
              </div>
            </article>
          ))}
        </div>
      )}

      <style>{`
        .blog-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 24px; }
        .blog-card { background: white; border-radius: var(--radius-xl); overflow: hidden; border: 1px solid var(--cream-dark); display: flex; flex-direction: column; }
        .blog-card img { width: 100%; height: 220px; object-fit: cover; }
        .blog-card-body { padding: 22px; display: flex; flex-direction: column; gap: 14px; }
        .blog-card-meta { color: var(--text-light); font-size: .82rem; letter-spacing: .04em; text-transform: uppercase; }
        .blog-card h2 { margin: 0; font-size: 1.3rem; line-height: 1.2; }
        .blog-card p { color: var(--text-mid); line-height: 1.8; }
        @media(max-width: 980px) { .blog-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
        @media(max-width: 680px) { .blog-grid { grid-template-columns: 1fr; } }
      `}</style>
    </div>
  );
}
